import React, { Component, MouseEvent } from "react";
import { history } from "@my-dld/reducers/store";
import Strings from "@my-dld/assets/strings";
import { AppConstants } from "../configApp";
import { LocaleUtil } from "@eres/core";
import { Route, RouteComponentProps } from "react-router";
import { ConnectedRouter } from "connected-react-router";
import AppContextWrapper, { AppContext } from "@my-dld/contexts/AppContext";
import { getSiteLocaleRootUrl, RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { TWIMC } from "@my-dld/utils/TabuServices";
import { TabuProfile } from "@10x/sso/TabuProfile";
import { isEmailVerified } from "@my-dld/utils/User";
import { showUnverifiedEmailError } from "@my-dld/utils/UIUtils";
import { initRegistration } from "@my-dld/screens/Register/ctx";

interface Prop extends RoutedViewProps {
	mobile?: boolean;
	menuId?: string;
}

interface State {
}

function Header( pros: { isMobileUI: boolean; label: string } ) {
	const { isMobileUI, label } = pros;
	if ( isMobileUI ) {
		return <button
			className="btn dropdown-toggle" type="button"
			data-bs-toggle="dropdown">{ label }</button>;

	}
	return <button
		className="btn dropdown-toggle dld-sub-header__btn rounded-circle" type="button"
		data-bs-toggle="dropdown"><i className="secondary--text icon-account dld-icon-md"></i><span
		className="sr-only">{ label }</span></button>;

}

class Me extends Component<Prop, State> {
	static contextType = AppContext;
	context!: React.ContextType<typeof AppContext>;
	rootUrl = AppConstants.rootUrlLocale;

	constructor( props: Prop ) {
		super( props );
	}

	render() {
		const isMobileUI = this.props.mobile === true;
		if ( this.context.user ) {
			const isTabuUser = TabuProfile.getProfile() != undefined;
			let uTypeLabel = undefined;
			if ( isTabuUser ) {
				uTypeLabel = Strings.owner_register_label;
			} else {
				uTypeLabel = Strings.bussiness_users;
			}
			return (
				<React.Fragment>
					<div className="dropdown dropdown-user user-logged-in">
						<Header isMobileUI={ isMobileUI } label={ Strings.my_dld }/>
						<ul className="dropdown-menu dropdown-menu-end">
							{ !isMobileUI && <li className="ddl-title"><span>{ Strings.my_dld }</span></li> }
							<li>
								<button
									className="dropdown-item"
									onClick={ this.viewDashboard }>
									{ Strings.my_dashboard } { uTypeLabel &&
									<span>({ uTypeLabel })</span> }
								</button>
							</li>
							{ isTabuUser &&
								<li>
									<button
										className="dropdown-item"
										onClick={ e => this.tabuRequest( e, "mydld/taburequest/twimc" ) }>
										{ LocaleUtil.getLocalValue( TWIMC.Name ) }
									</button>
								</li>
							}
							<li>
								<button
									className="dropdown-item"
									onClick={ this.viewProfile }>
									{ Strings.my_profile }
								</button>
							</li>
							<li>
								<button
									className="dropdown-item"
									onClick={ this.logout }>
									{ Strings.sign_out }
								</button>
							</li>
						</ul>
					</div>
				</React.Fragment>
			);
		}
		return (
			<React.Fragment>
				<div className="dropdown dropdown-user">
					<Header isMobileUI={ isMobileUI } label={ Strings.user_login }/>
					<ul className="dropdown-menu dropdown-menu-end">
						<li className="ddl-title"><span>{ Strings.login_as }</span></li>
						<li>
							<button
								className="dropdown-item"
								onClick={ e => this.login( e, "/sso" ) }>
								{ Strings.bussiness_users }
							</button>
						</li>
						<li>
							<button
								className="dropdown-item"
								onClick={ e => this.login( e, "/owner" ) }>
								{ Strings.owner_login_label }
							</button>
						</li>
						<li>
							<a
								href={ `${ window.apiConfig.brokerApp }` }
								rel={ "noopener noreferrer" }
								target="_blank" className="dropdown-item">
								{ Strings.login_to_dubai_broker_app }
							</a>
						</li>
						<li>
							<hr className="dropdown-divider"/>
						</li>
						<li className="ddl-title mt-2"><span>{ Strings.register_as }</span></li>
						<li>
							<button
								className="dropdown-item" type="button"
								onClick={ this.registerSSO }
							>{ Strings.reg_a_business_user }</button>
						</li>
						<li>
							<button
								className="dropdown-item" type="button"
								onClick={ this.registerIndividual }
							>{ Strings.reg_an_individual }</button>
						</li>
						<li>
							<hr className="dropdown-divider"/>
						</li>
						<li className="user-definition">
							<button
								className="dropdown-item" type="button" data-bs-toggle="modal"
								data-bs-target="#loginInfoDialog">{ Strings.mnu_login_help }
							</button>
						</li>
					</ul>
				</div>
			</React.Fragment>
		);
	}

	login = ( e: MouseEvent, path: string ) => {
		e.preventDefault();
		window.$( ".dropdown.open .dropdown-toggle" ).dropdown( "toggle" );
		if ( window && window.AppInfo && window.AppInfo.loginPage ) {
			window.location.href = getSiteLocaleRootUrl() + window.AppInfo.loginPage;
		} else
			this.redirectX( "login" + path );
	};
	registerSSO = ( e: MouseEvent ) => {
		e.preventDefault();
		window.$( ".dropdown.open .dropdown-toggle" ).dropdown( "toggle" );
		this.redirectX( "sso/register" );
	};
	registerIndividual = ( e: MouseEvent ) => {
		e.preventDefault();
		window.$( ".dropdown.open .dropdown-toggle" ).dropdown( "toggle" );
		initRegistration();
		this.redirectX( "register" );
	};
	viewDashboard = ( e: MouseEvent ) => {
		e.preventDefault();
		window.$( "#logo-container" ).trigger( "mouseover" );
		this.redirectX( "mydld" );
	};
	viewProfile = ( e: MouseEvent ) => {
		e.preventDefault();
		window.$( "#logo-container" ).trigger( "mouseover" );
		this.redirectX( "mydld/profile" );
	};
	tabuRequest = ( e: MouseEvent, path: string ) => {
		e.preventDefault();
		if ( isEmailVerified() ) {
			window.$( "#logo-container" ).trigger( "mouseover" );
			this.redirectX( path );
		} else {
			showUnverifiedEmailError();
		}
	};

	redirectX( path: string ) {
		this.hideMenu( () => {
			if ( window.hasMyDLD ) {
				if ( path === "login" ) {
					this.props.history.replace( "/" + path );
				} else
					this.props.history.push( "/" + path );
			} else {
				window.location.href = this.rootUrl + "MyDLD/#/" + path;
			}
		} );
	}

	hideMenu( work: () => any ) {
		const isMobileUI = this.props.mobile === true;
		if ( isMobileUI ) {
			const menuId = this.props.menuId ?? "navbar-collapse-1";
			const collapse = window.bootstrap.Collapse.getInstance( document.getElementById( menuId ) );
			if ( collapse )
				collapse.hide?.();
			work();
		} else {
			window.$( ".nav-x" ).addClass( "noHover" );
			work();
			let x = setInterval( () => {
				let v = window.$( ".nav-x.noHover" ).length;
				if ( v >= 1 ) {
					let v = window.$( ".nav-x.noHover" ).removeClass( "noHover" );
					clearInterval( x );
				}
			}, 200 );
		}

	}

	logout = ( e: MouseEvent ) => {
		e.preventDefault();
		this.hideMenu( () => {
			if ( window.showMyDLDLogout ) window.showMyDLDLogout();
		} );
	};
}


export default class RouterMe extends Component<Prop> {
	render() {
		return <ConnectedRouter history={ history }>
			<AppContextWrapper componentId={ "Me" }>
				<Route
					render={ ( props: RouteComponentProps<any> ) => {
						return <Me { ...{ ...this.props, ...props } }/>;
					} }>
				</Route>
			</AppContextWrapper>
		</ConnectedRouter>;
	}
}
